(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abe-service-form"] && !Shopify.designMode) return;
  try {
    
  class AbeServiceForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.abeForm = this.querySelector('[data-abe-cart-form]');
      this.errorBox = this.querySelector('[data-abe-error]');
      this.requiredControls = Array.from(this.querySelectorAll('[required]'));
      this.birthdateInput = this.querySelector('[data-abe-birthdate]');
      this.submitButton = this.querySelector('[data-abe-submit]');
      this.variantInput = this.querySelector('[data-abe-variant-id]');

      this.setupModelCombobox();

      this.querySelectorAll('[data-abe-file]').forEach((input) => {
        const label = input.closest('.abe-service-form__upload')?.querySelector('[data-abe-file-label]');
        if (label) label.dataset.defaultText = label.textContent;
        input.addEventListener('change', () => this.updateFileLabel(input));
      });

      document.addEventListener(
        'click',
        (event) => {
          const scrollTrigger = event.target.closest('[data-abe-scroll-trigger]');
          if (!scrollTrigger) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (!this.validate()) return;
          this.scrollToFormActions();
        },
        true
      );

      if (this.abeForm) {
        this.abeForm.addEventListener('submit', (event) => {
          if (this.submitButton?.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            return;
          }

          if (!this.validate() || !this.syncCartFields()) {
            event.preventDefault();
            return;
          }

          this.setSubmitting(true);
        });
      }
    }

    setupModelCombobox() {
      this.modelSelectRoot = this.querySelector('[data-abe-model-select-root]');
      this.modelSelect = this.querySelector('[data-abe-model-select]');
      this.modelCombobox = this.querySelector('[data-abe-model-combobox]');
      this.modelSearch = this.querySelector('[data-abe-model-search]');
      this.modelToggle = this.querySelector('[data-abe-model-toggle]');
      this.modelPanel = this.querySelector('[data-abe-model-panel]');
      this.modelList = this.querySelector('[data-abe-model-list]');
      this.modelEmpty = this.querySelector('[data-abe-model-empty]');

      if (
        !this.modelSelectRoot ||
        !this.modelSelect ||
        !this.modelCombobox ||
        !this.modelSearch ||
        !this.modelPanel ||
        !this.modelList ||
        !this.modelEmpty
      ) {
        return;
      }

      const sourceOptions = Array.from(this.modelSelect.options).filter((option) => option.value);
      const fragment = document.createDocumentFragment();

      this.modelOptionItems = sourceOptions.map((option, index) => {
        const item = document.createElement('div');
        item.id = `${this.modelList.id}-option-${index}`;
        item.className = 'abe-service-form__combobox-option';
        item.dataset.value = option.value;
        item.dataset.searchValue = this.normalizeModelValue(`${option.textContent} ${option.value}`);
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.textContent = option.textContent.trim();
        item.addEventListener('pointerdown', (event) => event.preventDefault());
        item.addEventListener('click', () => this.selectModelOption(item));
        fragment.appendChild(item);
        return item;
      });

      this.modelList.appendChild(fragment);
      this.visibleModelOptions = this.modelOptionItems.slice();
      this.activeModelIndex = -1;
      this.modelSelectRoot.classList.add('is-enhanced');
      this.modelSelect.tabIndex = -1;
      this.modelSelect.setAttribute('aria-hidden', 'true');
      this.modelCombobox.hidden = false;
      this.syncModelSelection();

      this.modelSearch.addEventListener('focus', () => {
        this.openModelCombobox();
        if (this.modelSelect.value) requestAnimationFrame(() => this.modelSearch.select());
      });
      this.modelSearch.addEventListener('click', () => this.openModelCombobox());
      this.modelSearch.addEventListener('input', () => {
        const selectedOption = this.modelSelect.selectedOptions[0];
        if (
          this.modelSelect.value &&
          selectedOption &&
          this.modelSearch.value !== selectedOption.textContent.trim()
        ) {
          this.modelSelect.value = '';
          this.modelOptionItems.forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-selected', 'false');
          });
        }
        this.openModelCombobox();
        this.filterModelOptions(this.modelSearch.value, true);
      });
      this.modelSearch.addEventListener('keydown', (event) => this.handleModelKeydown(event));
      this.modelToggle?.addEventListener('pointerdown', (event) => event.preventDefault());
      this.modelToggle?.addEventListener('click', () => {
        if (this.modelPanel.hidden) {
          this.modelSearch.focus();
        } else {
          this.closeModelCombobox(true);
          this.modelSearch.focus();
        }
      });
      this.modelSelect.addEventListener('change', () => this.syncModelSelection());
      this.querySelector(`#${CSS.escape(this.modelSearch.getAttribute('aria-labelledby'))}`)?.addEventListener('click', (event) => {
        event.preventDefault();
        this.modelSearch.focus();
      });
      document.addEventListener('pointerdown', (event) => {
        if (!this.modelCombobox.contains(event.target)) this.closeModelCombobox(true);
      });
    }

    normalizeModelValue(value) {
      return value.normalize('NFKD').toLocaleLowerCase().replace(/[\s_-]+/g, '');
    }

    openModelCombobox() {
      if (!this.modelPanel?.hidden) return;
      this.modelPanel.hidden = false;
      this.modelCombobox.classList.add('is-open');
      this.modelSearch.setAttribute('aria-expanded', 'true');
      this.filterModelOptions(this.modelSelect.value ? '' : this.modelSearch.value, false);
    }

    closeModelCombobox(restoreValue = false) {
      if (!this.modelPanel || this.modelPanel.hidden) return;
      if (restoreValue) this.syncModelSelection();
      this.modelPanel.hidden = true;
      this.modelCombobox.classList.remove('is-open');
      this.modelSearch.setAttribute('aria-expanded', 'false');
      this.setActiveModelOption(-1);
    }

    filterModelOptions(query, activateFirst) {
      const normalizedQuery = this.normalizeModelValue(query);
      this.visibleModelOptions = this.modelOptionItems.filter((item) => {
        const matches = !normalizedQuery || item.dataset.searchValue.includes(normalizedQuery);
        item.hidden = !matches;
        return matches;
      });
      this.modelEmpty.hidden = this.visibleModelOptions.length > 0;
      this.setActiveModelOption(activateFirst && this.visibleModelOptions.length ? 0 : -1);
    }

    setActiveModelOption(index) {
      this.modelOptionItems.forEach((item) => item.classList.remove('is-active'));
      this.activeModelIndex = index;

      const activeItem = this.visibleModelOptions[index];
      if (!activeItem) {
        this.modelSearch.removeAttribute('aria-activedescendant');
        return;
      }

      activeItem.classList.add('is-active');
      this.modelSearch.setAttribute('aria-activedescendant', activeItem.id);
      activeItem.scrollIntoView({ block: 'nearest' });
    }

    selectModelOption(item) {
      this.modelSelect.value = item.dataset.value;
      this.syncModelSelection();
      this.modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.closeModelCombobox(false);
      this.modelSearch.focus();
    }

    syncModelSelection() {
      if (!this.modelSelect || !this.modelSearch) return;
      const selectedOption = this.modelSelect.selectedOptions[0];
      this.modelSearch.value = this.modelSelect.value && selectedOption ? selectedOption.textContent.trim() : '';
      this.modelOptionItems?.forEach((item) => {
        const isSelected = Boolean(this.modelSelect.value) && item.dataset.value === this.modelSelect.value;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', String(isSelected));
      });

      if (this.modelSelect.value) {
        this.modelSelect.classList.remove('is-invalid');
        this.modelSelect.removeAttribute('aria-invalid');
        this.modelCombobox.classList.remove('is-invalid');
        this.modelSearch.removeAttribute('aria-invalid');
      }
    }

    handleModelKeydown(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.openModelCombobox();
        if (!this.visibleModelOptions.length) return;
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = this.activeModelIndex < 0
          ? (direction > 0 ? 0 : this.visibleModelOptions.length - 1)
          : (this.activeModelIndex + direction + this.visibleModelOptions.length) % this.visibleModelOptions.length;
        this.setActiveModelOption(nextIndex);
        return;
      }

      if (event.key === 'Enter' && !this.modelPanel.hidden) {
        const activeItem = this.visibleModelOptions[this.activeModelIndex];
        if (activeItem) {
          event.preventDefault();
          this.selectModelOption(activeItem);
        }
        return;
      }

      if (event.key === 'Escape' && !this.modelPanel.hidden) {
        event.preventDefault();
        this.closeModelCombobox(true);
        return;
      }

      if (event.key === 'Tab') this.closeModelCombobox(true);
    }

    updateFileLabel(input) {
      const label = input.closest('.abe-service-form__upload')?.querySelector('[data-abe-file-label]');
      if (!label) return;
      label.textContent = input.files && input.files.length ? input.files[0].name : label.dataset.defaultText;
    }

    scrollToFormActions() {
      const target = this.querySelector('.abe-service-form__actions') || this;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.querySelector('.abe-service-form__submit')?.focus({ preventScroll: true });
    }

    syncCartFields() {
      const variantId = this.variantInput?.value;
      if (!variantId) {
        this.showError();
        return false;
      }

      return true;
    }


    setSubmitting(isSubmitting) {
      if (!this.submitButton) return;
      this.submitButton.toggleAttribute('aria-disabled', isSubmitting);
      this.submitButton.classList.toggle('loading', isSubmitting);
      this.submitButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !isSubmitting);
    }

    validate() {
      let firstInvalid = null;
      this.hideError();

      this.requiredControls.forEach((control) => {
        control.classList.remove('is-invalid');
        control.removeAttribute('aria-invalid');
        if (control === this.modelSelect) {
          this.modelCombobox?.classList.remove('is-invalid');
          this.modelSearch?.removeAttribute('aria-invalid');
        }

        if (!control.checkValidity()) {
          firstInvalid = firstInvalid || control;
          this.markInvalid(control);
        }
      });

      if (this.birthdateInput && !this.isAdultBirthdate(this.birthdateInput.value)) {
        firstInvalid = firstInvalid || this.birthdateInput;
        this.markInvalid(this.birthdateInput);
      }

      if (firstInvalid) {
        this.showError();
        this.focusInvalidControl(firstInvalid);
        return false;
      }

      return true;
    }

    markInvalid(control) {
      control.classList.add('is-invalid');
      control.setAttribute('aria-invalid', 'true');
      if (control === this.modelSelect) {
        this.modelCombobox?.classList.add('is-invalid');
        this.modelSearch?.setAttribute('aria-invalid', 'true');
      }
    }

    focusInvalidControl(control) {
      const focusTarget = control === this.modelSelect ? this.modelSearch : control;
      if (control === this.modelSelect) this.openModelCombobox();
      focusTarget?.focus({ preventScroll: true });
      focusTarget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    showError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = false;
      this.errorBox.focus({ preventScroll: true });
    }

    hideError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = true;
    }

    isAdultBirthdate(value) {
      const match = value.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
      if (!match) return false;

      const day = Number(match[1]);
      const month = Number(match[2]);
      const year = Number(match[3]);
      const birthdate = new Date(year, month - 1, day);

      if (
        birthdate.getFullYear() !== year ||
        birthdate.getMonth() !== month - 1 ||
        birthdate.getDate() !== day
      ) {
        return false;
      }

      const today = new Date();
      const minimum = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
      return birthdate <= minimum;
    }
  }

  if (!customElements.get('abe-service-form')) {
    customElements.define('abe-service-form', AbeServiceForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      if (this.closeSearchModal) {
        this.closeSearchModal();
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-support-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('support-faq')) {
    customElements.define('support-faq', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-faq-search]');
        this.clearButton = this.querySelector('[data-faq-clear]');
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.filters = Array.from(this.querySelectorAll('[data-category]'));
        this.empty = this.querySelector('[data-faq-empty]');
        this.count = this.querySelector('[data-faq-result-count]');
        this.activeCategory = 'all';
        this.querySelector('[data-faq-search-form]')?.addEventListener('submit', event => event.preventDefault());
        this.input?.addEventListener('input', () => this.filter());
        this.clearButton?.addEventListener('click', () => this.resetSearch());
        this.querySelector('[data-faq-reset]')?.addEventListener('click', () => this.resetAll());
        this.filters.forEach(button => button.addEventListener('click', () => this.selectCategory(button)));
      }
      normalize(value) {
        return value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      }
      selectCategory(button) {
        this.activeCategory = button.dataset.category;
        this.filters.forEach(filter => {
          const active = filter === button;
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.filter();
      }
      filter() {
        const term = this.normalize(this.input?.value || '');
        let visible = 0;
        this.items.forEach(item => {
          const matchesCategory = this.activeCategory === 'all' || item.dataset.category === this.activeCategory;
          const matchesTerm = !term || this.normalize(item.dataset.searchText || '').includes(term);
          const show = matchesCategory && matchesTerm;
          item.hidden = !show;
          if (show) visible += 1;
        });
        if (this.clearButton) this.clearButton.hidden = !term;
        if (this.empty) this.empty.hidden = visible !== 0;
        if (this.count) {
          const template = this.count.dataset.resultTemplate || '[count]';
          this.count.textContent = template.replace('[count]', visible);
        }
      }
      resetSearch() {
        if (this.input) {
          this.input.value = '';
          this.input.focus();
        }
        this.filter();
      }
      resetAll() {
        if (this.input) this.input.value = '';
        const allButton = this.filters.find(button => button.dataset.category === 'all');
        if (allButton) this.selectCategory(allButton);
        this.input?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valden-gt-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeValdenLandingPage = (root) => {
      const visual = root.querySelector('[data-vgt-hero-visual]');
      const canTilt = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (visual && canTilt && !reduceMotion && visual.dataset.vgtTiltReady !== 'true') {
        visual.dataset.vgtTiltReady = 'true';
        let bounds;

        const resetTilt = () => {
          bounds = null;
          visual.style.transform = '';
        };

        visual.addEventListener('pointerenter', () => {
          bounds = visual.getBoundingClientRect();
        }, { passive: true });
        visual.addEventListener('pointermove', (event) => {
          if (!bounds) bounds = visual.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          const rotateY = (x * 10).toFixed(2);
          const rotateX = (-y * 8).toFixed(2);
          const translateX = (x * 4).toFixed(2);
          const translateY = (-4 - y * 4).toFixed(2);
          visual.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.018)`;
        }, { passive: true });
        visual.addEventListener('pointerleave', resetTilt, { passive: true });
        visual.addEventListener('pointercancel', resetTilt, { passive: true });
      }

      const insuranceRoot = root.querySelector('[data-vgt-insurance-root]');
      const productForm = root.querySelector('form[data-type="add-to-cart-form"]');

      if (insuranceRoot && productForm && insuranceRoot.dataset.vgtInsuranceReady !== 'true') {
        insuranceRoot.dataset.vgtInsuranceReady = 'true';
        const insuranceChoices = Array.from(insuranceRoot.querySelectorAll('[data-vgt-insurance-choice]'));
        const insuranceDetails = insuranceRoot.querySelector('[data-vgt-insurance-details]');
        const insuranceWerollChoice = insuranceRoot.querySelector('[data-vgt-insurance-weroll]');
        const insuranceFields = Array.from(insuranceRoot.querySelectorAll('[data-vgt-insurance-required]'));
        const insuranceError = insuranceRoot.querySelector('[data-vgt-insurance-error]');
        const insuranceHolderCount = insuranceRoot.querySelector('[data-vgt-insurance-holder-count]');
        const insuranceSecondHolder = insuranceRoot.querySelector('[data-vgt-insurance-second]');
        const insuranceModal = insuranceRoot.querySelector('[data-vgt-insurance-modal]');
        const insuranceModalOpen = insuranceRoot.querySelector('[data-vgt-insurance-modal-open]');
        const insuranceModalClose = insuranceRoot.querySelector('[data-vgt-insurance-modal-close]');

        const isInsuranceSelected = () => Boolean(insuranceWerollChoice && insuranceWerollChoice.checked);
        const getHolderCount = () => insuranceHolderCount && insuranceHolderCount.value === '2' ? 2 : 1;
        const formatGermanDate = (value) => {
          const digits = (value || '').replace(/\D/g, '').slice(0, 8);
          if (digits.length <= 2) return digits;
          if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
          return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
        };
        const isValidGermanBirthDate = (value) => {
          const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec((value || '').trim());
          if (!match) return false;
          const day = Number(match[1]);
          const month = Number(match[2]);
          const year = Number(match[3]);
          const now = new Date();
          const date = new Date(year, month - 1, day);
          return year >= now.getFullYear() - 120 && year <= now.getFullYear() && date <= now
            && date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
        };
        const syncInsurance = () => {
          const active = isInsuranceSelected();
          const needsSecondHolder = active && getHolderCount() === 2;
          if (insuranceDetails) insuranceDetails.hidden = !active;
          insuranceFields.forEach((field) => {
            const isSecondField = field.hasAttribute('data-vgt-insurance-second-required');
            const enabled = active && (!isSecondField || needsSecondHolder);
            field.disabled = !enabled;
            field.required = enabled;
          });
          if (insuranceHolderCount) {
            insuranceHolderCount.disabled = !active;
            insuranceHolderCount.required = active;
          }
          if (insuranceSecondHolder) insuranceSecondHolder.hidden = !needsSecondHolder;
          insuranceChoices.forEach((choice) => {
            const option = choice.closest('[data-vgt-insurance-option]');
            if (option) option.classList.toggle('is-selected', choice.checked);
          });
          if (!active && insuranceError) insuranceError.hidden = true;
        };
        const validateInsurance = (showError) => {
          if (!isInsuranceSelected()) return true;
          const invalid = insuranceFields.find((field) => {
            if (field.disabled) return false;
            if (field.type === 'checkbox') return !field.checked;
            if (field.hasAttribute('data-vgt-insurance-birth')) return !isValidGermanBirthDate(field.value);
            if (field.type === 'email') return !field.value || !field.validity.valid;
            return !field.value || field.value.trim() === '';
          });
          if (insuranceError) insuranceError.hidden = !showError || !invalid;
          if (invalid && showError) invalid.focus();
          return !invalid;
        };
        const getInsuranceProperties = () => {
          const selected = insuranceChoices.find((choice) => choice.checked);
          if (!selected) return {};
          const properties = {
            'Pflichtversicherung': selected.value || '',
            'ERGO Versicherungstyp': insuranceRoot.dataset.insuranceType || ''
          };
          if (!isInsuranceSelected()) return properties;
          const value = (selector) => {
            const field = insuranceRoot.querySelector(selector);
            return field ? field.value.trim() : '';
          };
          const priceElement = insuranceRoot.querySelector('.weroll-0526-svc__insurance-price');
          properties.Versicherungspreis = priceElement ? priceElement.textContent.trim() : '';
          properties['Anzahl der Versicherungsnehmer'] = String(getHolderCount());
          properties['Versicherung - Name'] = value('[data-vgt-insurance-name]');
          properties['Versicherung - Geburtsdatum'] = value('[data-vgt-insurance-birth]');
          const consentElement = insuranceRoot.querySelector('[data-vgt-insurance-consent]');
          properties['ERGO Datenschutz Zustimmung'] = consentElement && consentElement.checked ? 'Ja' : '';
          if (getHolderCount() === 2) {
            properties['Versicherung 2 - Vorname'] = value('[data-vgt-insurance-second-first-name]');
            properties['Versicherung 2 - Nachname'] = value('[data-vgt-insurance-second-last-name]');
            properties['Versicherung 2 - Geburtsdatum'] = value('[data-vgt-insurance-second-birth]');
            properties['Versicherung 2 - Email'] = value('[data-vgt-insurance-second-email]');
            properties['Versicherung 2 - Strasse Hausnummer'] = value('[data-vgt-insurance-second-street]');
            properties['Versicherung 2 - Postleitzahl'] = value('[data-vgt-insurance-second-postal]');
            properties['Versicherung 2 - Ort'] = value('[data-vgt-insurance-second-city]');
          }
          return properties;
        };
        const addItemsToCart = async (items) => {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.description || result.message || 'Der Warenkorb konnte nicht aktualisiert werden.');
        };

        const handleInsuranceSubmit = async (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!validateInsurance(true)) return;
          const variantInput = productForm.querySelector('input[name="id"]');
          const submitButton = productForm.querySelector('[type="submit"]');
          const mainId = Number(variantInput ? variantInput.value : 0);
          const insuranceId = Number(insuranceRoot.dataset.variantId || 0);
          if (!mainId || (isInsuranceSelected() && !insuranceId)) return;
          const quantityInput = productForm.querySelector('[name="quantity"]');
          const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1));
          const properties = getInsuranceProperties();
          if (submitButton) { submitButton.disabled = true; submitButton.dataset.vgtSubmitting = 'true'; }
          try {
            const items = [{ id: mainId, quantity, properties }];
            if (isInsuranceSelected()) items.push({ id: insuranceId, quantity: getHolderCount(), properties });
            await addItemsToCart(items);
            window.location.href = '/cart';
          } catch (error) {
            if (insuranceError) {
              insuranceError.textContent = error.message || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.';
              insuranceError.hidden = false;
            }
            if (submitButton) { submitButton.disabled = false; delete submitButton.dataset.vgtSubmitting; }
          }
        };

        productForm.addEventListener('submit', handleInsuranceSubmit, true);
        insuranceChoices.forEach((choice) => choice.addEventListener('change', syncInsurance));
        if (insuranceHolderCount) insuranceHolderCount.addEventListener('change', syncInsurance);
        insuranceRoot.querySelectorAll('[data-vgt-insurance-birth]').forEach((field) => {
          field.addEventListener('input', (event) => { event.target.value = formatGermanDate(event.target.value); });
        });
        if (insuranceModalOpen && insuranceModal) {
          insuranceModalOpen.addEventListener('click', (event) => {
            event.preventDefault();
            if (typeof insuranceModal.showModal === 'function') insuranceModal.showModal();
            else insuranceModal.setAttribute('open', '');
          });
          if (insuranceModalClose) {
            insuranceModalClose.addEventListener('click', () => {
              if (typeof insuranceModal.close === 'function') insuranceModal.close();
              else insuranceModal.removeAttribute('open');
            });
          }
          insuranceModal.addEventListener('click', (event) => {
            if (event.target === insuranceModal) {
              if (typeof insuranceModal.close === 'function') insuranceModal.close();
              else insuranceModal.removeAttribute('open');
            }
          });
        }
        syncInsurance();
      }

      const select = root.querySelector('[data-vgt-variant-select]');
      if (!select) return;

      const form = select.closest('form');
      const variantInput = form && form.querySelector('input[name="id"]');
      const submitButton = form && form.querySelector('[type="submit"]');
      const submitLabel = submitButton && submitButton.querySelector('span');
      const priceTargets = root.querySelectorAll('[data-vgt-price]');

      const updateVariant = () => {
        const option = select.options[select.selectedIndex];
        const isAvailable = option.dataset.available === 'true';

        if (variantInput) {
          variantInput.value = option.value;
          variantInput.disabled = !isAvailable;
        }
        priceTargets.forEach((target) => { target.textContent = option.dataset.price; });

        if (submitButton && submitLabel) {
          submitButton.disabled = !isAvailable;
          submitLabel.textContent = isAvailable ? root.dataset.addToCartLabel : root.dataset.soldOutLabel;
        }
      };

      select.addEventListener('change', updateVariant);
      updateVariant();
    };

    document.querySelectorAll('[data-vgt-section]').forEach(initializeValdenLandingPage);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-vgt-section]');
      if (root) initializeValdenLandingPage(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
